import { render, staticRenderFns } from "./GlobalSearchOrder.vue?vue&type=template&id=4aadc7ac"
import script from "./GlobalSearchOrder.vue?vue&type=script&lang=js"
export * from "./GlobalSearchOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports